import { z } from 'zod';
import { AiProvenanceSchema } from '../../shared/ai-provenance';
import { BaseErrorSchema } from '../../shared/error.schema';
export const GenerateDraftStepSummaryRequestSchema = z.void();
export const GenerateDraftStepSummaryResponseSchema = z.object({
    name: z.string(),
    description: z.string(),
    aiProvenance: AiProvenanceSchema.optional()
});
export const GenerateDraftStepSummaryErrorSchema = BaseErrorSchema;

//# sourceMappingURL=generate-draft-step-summary.schema.js.map